module.exports = __webpack_public_path__ + "static/media/bi.21c1ff1f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bi.svg
// module id = 1190
// module chunks = 0